<template>
    <div class="text-xs-center">
        <v-dialog v-model="show" persistent width="50%">
            <v-toolbar class="toolbar-element" light flat height="90em">
                <v-toolbar-title class="toolbar-title">Historial de consulta</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-items>
                    <v-btn icon @click="hideDialog"><v-icon color="grey darken-1">close</v-icon></v-btn>
                </v-toolbar-items>
            </v-toolbar>
            <v-card class="body-content">
                <v-container>
                    <v-card light flat class="pt-2">
                        <v-card-text>
                            <div v-if="history.length === 0">
                                <v-layout row justify-left>
                                    <div>No se han realizado derivaciones</div>
                                </v-layout>
                            </div>
                            <div v-else v-for="item in history" :key="item.id">
                                <v-layout row justify-left>
                                    <v-flex xs3>
                                        <span>{{ item.historyDate }}</span>
                                    </v-flex>
                                    <v-flex xs9>
                                        <span>Consulta </span>
                                        <span><b>{{ item.historyChangeReason }}</b></span>
                                        <span> por </span>
                                        <span><b>{{ item.historyUser.firstName }} </b></span>
                                        <span><b>{{ item.historyUser.lastName }}</b></span>
                                        <template v-if="item.historyChangeReason !== 'Cerrada'">
                                            <span> al departamento </span>
                                            <span><b>{{ item.departamento }}</b></span>
                                        </template>
                                    </v-flex>
                                </v-layout>
                                <v-divider class="my-2" color="#DCDCDC"></v-divider>
                            </div>
                        </v-card-text>
                    </v-card>
                </v-container>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
export default {
  props: {
    history: Array
  },

  data () {
    return {
      show: true
    }
  },

  methods: {
    showDialog () {
      this.show = true
    },
    hideDialog () {
      this.$emit('hideHistoryDialog')
    }
  }
}
</script>

<style scoped>
    .toolbar-element {
        background: linear-gradient(#e2e2e2, #cbd1db);
    }
    .toolbar-title {
        font-size: 2.2em;
        font-family: SourceSansProLight, sans-serif;
        color: #293968;
    }
    .body-content {
        background-color: #eaeaea;
        padding-top: 0.5em;
        padding-bottom: 2.5em;
    }
</style>
